var ActusList = {

	interval_nav:0,
	isMoving:false,
	xDest:0,
	yDest:0,

	init:function(){
		
		/*
		$(".actus--list").mousemove(function(e){

			ActusList.xDest = Math.round(e.pageX - $(this).offset().left);
			ActusList.yDest = Math.round(e.pageY - $(this).offset().top) - 45;

			if((ActusList.yDest < $(this).find(".slick-current .img-container").outerHeight() - 30)&&(ActusList.yDest > -45)){
			
				
			$(this).addClass("no-cursor");
			$(this).find(".nav").addClass("visible");
	
			}else{

			$(this).removeClass("no-cursor");
			$(this).find(".nav").removeClass("visible");
				
			}
			
			ActusList.move();
			

		}).mouseleave(function(){
			console.log("MOUSE LEAVE");
			$(this).find(".nav").removeClass("visible");		
		})
		*/
	},
	move:function(){
		/*
		$(".actus--list .nav").css({left:ActusList.xDest, top:ActusList.yDest});
		*/
	}
}
